export enum Permission {
  UPLOAD_FILES = "UIHomePage:UploadFilesButton",
  ADD_FOLDER = "UIHomePage:AddFolderButton",
  IMPORT_TEAMS = "UIHomePage:ImportTeamsButton",
  DELETE = "UIHomePage:DeleteButton",
  MOVE_TO_FOLDER = "UIHomePage:MoveToFolderButton",
  DOWNLOAD = "UIHomePage:DownloadButton",
  CHECKBOXES = "UIHomePage:CheckBoxes",
  FOLDER_ACTION_RENAME = "UIActionsFolder:Rename",
  FOLDER_ACTION_DOWNLOAD = "UIActionsFolder:Download",
  FOLDER_ACTION_MOVE_TO = "UIActionsFolder:MoveTo",
  FOLDER_ACTION_DELETE = "UIActionsFolder:Delete",
  FILE_ACTION_EDIT = "UIActionsFile:Edit",
  FILE_ACTION_UPDATE_VERSION = "UIActionsFile:UpdateVersion",
  FILE_ACTION_DOWNLOAD = "UIActionsFile:Download",
  FILE_ACTION_MOVE_TO = "UIActionsFile:MoveTo",
  FILE_ACTION_DELETE = "UIActionsFile:Delete",
  VIEWER_EDIT = "UIViewer:Edit",
  VIEWER_DOWNLOAD = "UIViewer:Download",
  VIEWER_UPDATE = "UIViewer:Update",
  VIEWER_DELETE = "UIViewer:Delete",
  VIEWER_SUMMARY = "UIViewer:Summary",
}
